var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.794 13.218H17.7405C17.1649 13.218 16.699 13.684 16.699 14.2596V18.4326C16.699 19.0082 17.1649 19.4741 17.7405 19.4741H25.093C24.2913 21.5641 22.7838 23.3114 20.872 24.4214L24.0035 29.8484C29.0262 26.9431 32 21.8381 32 16.1302C32 15.3148 31.9384 14.7324 31.8219 14.0814C31.726 13.5812 31.2943 13.218 30.794 13.218Z",
    fill: "#167EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.7371C12.4026 25.7371 9.26425 23.7705 7.57859 20.8651L2.15161 23.9897C4.91307 28.7795 10.0865 32 16 32C18.9054 32 21.6394 31.2189 24.0034 29.8553V29.8484L20.872 24.4214C19.433 25.2574 17.7747 25.7371 16 25.7371Z",
    fill: "#12B347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9966 29.8552V29.8484L20.8651 24.4214C19.433 25.2505 17.7747 25.737 16 25.737V32C18.9054 32 21.6394 31.2188 23.9966 29.8552Z",
    fill: "#0F993E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26296 16C6.26296 14.2252 6.74947 12.567 7.57859 11.1349L2.15161 8.01025C0.781156 10.3606 0 13.0878 0 16C0 18.9122 0.781156 21.6394 2.15161 23.9897L7.57859 20.8651C6.74261 19.433 6.26296 17.7747 6.26296 16Z",
    fill: "#FFD500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.26296C18.3435 6.26296 20.5019 7.09893 22.1807 8.48308C22.5987 8.8257 23.2017 8.79829 23.5786 8.42141L26.5319 5.46809C26.9636 5.0364 26.9293 4.33062 26.4702 3.93319C23.654 1.48009 19.988 0 16 0C10.0865 0 4.91307 3.22056 2.15161 8.01028L7.57859 11.1349C9.26425 8.22955 12.4026 6.26296 16 6.26296Z",
    fill: "#FF4B26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1807 8.48308C22.5987 8.8257 23.2017 8.79829 23.5786 8.42141L26.5319 5.46809C26.9636 5.0364 26.9293 4.33062 26.4702 3.93319C23.654 1.48009 19.988 0 16 0V6.26296C18.3435 6.26296 20.5019 7.09208 22.1807 8.48308Z",
    fill: "#D93F21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.21c5218c34940c6e442375b2eb2a66fd.svg";
export { ForwardRef as ReactComponent };